import { useEffect, type ReactNode } from 'react';
import { useAuth } from '../auth/AuthProvider.tsx';
import { erApiFeil } from './feil.ts';
import { useMe } from './useMe.ts';

/**
 * Binder API-ets dom om sesjonen til panelets tilstand (K8):
 *
 *   401                → logg ut, med serverens melding («Sesjonen er eldre enn 8 timer …»)
 *   403 mfa_required   → vurder sesjonen på nytt; leverandøren avgjør oppsett eller utfordring
 *   sessionExpiresAt   → en klokke som logger ut når timen er ute, uten å vente på et kall
 *
 * Klienten er aldri autoriteten — den speiler serveren så låsen forklares før
 * neste kall feiler.
 */
export function Sesjonsvakt({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const me = useMe(auth.tilstand.navn === 'innlogget');

  useEffect(() => {
    if (!me.error || !erApiFeil(me.error)) return;
    if (me.error.status === 401) void auth.loggUt(me.error.brukertekst);
    else if (me.error.status === 403 && me.error.code === 'mfa_required') void auth.oppdater();
  }, [me.error, auth]);

  useEffect(() => {
    if (!me.data) return;
    const gjenstaar = new Date(me.data.sessionExpiresAt).getTime() - Date.now();
    const id = setTimeout(() => void auth.loggUt('Sesjonen er avsluttet etter 8 timer. Logg inn på nytt.'), Math.max(gjenstaar, 0));
    return () => clearTimeout(id);
  }, [me.data, auth]);

  return <>{children}</>;
}
